/* Paperback bookshelf (sections/cl-paperback-shelf.liquid) and Digital Bundles page (sections/cl-bundle-shelf.liquid):
   deal bar, quick add, level and stock filters, series list highlight, "Show all" for folded shelves, and the
   Quick look popup. data-cfg "tiers" ([[count, percent], ...]) switches the deal bar from buy-X-get-Y to
   percent-off tiers. Claude, 2026-10-18. */
(function(){
  var root = document.getElementById('clPb');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(root.getAttribute('data-cfg')); } catch (e) { return; }
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var t = Date.now() / 1000, promo = (cfg.win || []).some(function(w){ return t >= w[0] && t < w[1]; });
  root.querySelectorAll('[data-when]').forEach(function(el){ el.hidden = (el.getAttribute('data-when') === 'promo') !== promo; });
  var B = promo ? cfg.pbuy : cfg.buy, G = promo ? cfg.pget : cfg.get, n = 0;
  var ids = {};
  root.querySelectorAll('[data-pid]').forEach(function(c){ ids[c.getAttribute('data-pid')] = 1; });
  var msg = root.querySelector('[data-msg]'), cnt = root.querySelector('[data-pb-count]');

  var unit = cfg.unit || 'book';
  function books(k){ return k + ' ' + (k === 1 ? unit : unit + 's'); }
  function tierMsg(){
    var T = cfg.tiers, cur = 0, next = null, top = T[T.length - 1];
    T.forEach(function(x){ if (n >= x[0]) cur = x[1]; });
    for (var i = 0; i < T.length; i++) { if (n < T[i][0]) { next = T[i]; break; } }
    if (n === 0) return '<strong>Save up to ' + top[1] + '% when you bundle.</strong> ' + T.map(function(x){ return x[1] + '% off ' + x[0]; }).join(', ') + '.';
    if (!next) return '<strong>' + books(n) + ' in your cart: ' + cur + '% off.</strong> The biggest discount, taken off at checkout.';
    var more = next[0] - n;
    if (!cur) return '<strong>' + books(n) + ' in your cart.</strong> Add ' + more + ' more and save ' + next[1] + '% on all of them.';
    return '<strong>' + books(n) + ' in your cart: ' + cur + '% off.</strong> Add ' + more + ' more for ' + next[1] + '% off.';
  }
  function bar(){
    if (cfg.pick) return;   /* the Single eBooks page draws its own bar (assets/cl-single-shelf.js) */
    if (cfg.tiers && cfg.tiers.length) { msg.innerHTML = tierMsg(); cnt.textContent = n ? ' (' + n + ')' : ''; return; }
    var set = B + G, r = n % set, free = Math.floor(n / set) * G, h;
    if (n === 0) h = '<strong>Buy ' + B + ', get ' + G + ' free.</strong> Mix any titles.';
    else if (r === 0) h = '<strong>' + books(n) + ' in your cart: ' + free + ' free.</strong> Add ' + B + ' more, then ' + (G === 1 ? 'the next one is' : 'the next ' + G + ' are') + ' free.';
    else if (r < B) h = '<strong>' + books(n) + ' in your cart.</strong> Add ' + (B - r) + ' more, then ' + (G === 1 ? 'the next one is' : 'the next ' + G + ' are') + ' free.';
    else h = '<strong>Add ' + (set - r) + ' more: ' + (set - r === 1 ? 'it’s' : 'they’re') + ' free.</strong>' + (free ? ' ' + free + ' free so far.' : '');
    msg.innerHTML = h;
    cnt.textContent = n ? ' (' + n + ')' : '';
  }
  function loadCart(){
    return fetch(base + 'cart.js', { headers: { 'Cache-Control': 'no-cache' } }).then(function(r){ return r.json(); }).then(function(c){
      n = 0;
      (c.items || []).forEach(function(it){ if (ids[String(it.product_id)]) n += it.quantity; });
      bar();
      try { root.dispatchEvent(new CustomEvent('cl:cart', { detail: c })); } catch (e) {}
      document.querySelectorAll('[data-cart-settings="count"] [data-count]').forEach(function(el){ el.textContent = c.item_count; });
    }).catch(function(){ bar(); });
  }
  bar(); loadCart();

  function addVariant(b){
    var lab = b.getAttribute('data-l') || 'Add';
    b.disabled = true; b.textContent = 'Adding…';
    fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +b.getAttribute('data-v'), quantity: 1 }] }) })
      .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
      .then(function(){ b.textContent = 'Added ✓'; b.classList.add('is-done'); return loadCart(); })
      .catch(function(j){ b.textContent = (j && j.description) ? 'Not available' : 'Try again'; })
      .then(function(){ setTimeout(function(){ b.disabled = false; b.textContent = lab; b.classList.remove('is-done'); }, 2200); });
  }

  var qv = document.getElementById('clQv');

  root.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var lk = e.target.closest('[data-qv]');
    if (lk && qv && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) { e.preventDefault(); open(lk.closest('.cl-pb__card')); return; }
    var b = e.target.closest('.cl-pb__add');
    if (b && !b.disabled) { addVariant(b); return; }
    var c = e.target.closest('.cl-pb__chip');
    if (c) {
      root.querySelectorAll('.cl-pb__chip').forEach(function(x){ var on = x === c; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
      filter(); return;
    }
    var j = e.target.closest('.cl-pb__jump a');
    if (j) { mark(j.getAttribute('data-jump')); return; }
    var mb = e.target.closest('[data-more]');
    if (mb) { var sf = mb.closest('.cl-pb__shelf'); if (sf) sf.classList.add('is-open'); return; }
    if (e.target.closest('[data-reset]')) {
      var all = root.querySelector('.cl-pb__chip[data-lv="all"]'); if (all) all.click();
      if (stockEl && stockEl.checked) { stockEl.checked = false; filter(); }
    }
  });
  var stockEl = root.querySelector('[data-stock]');
  if (stockEl) stockEl.addEventListener('change', filter);

  function filter(){
    var lv = (root.querySelector('.cl-pb__chip.is-on') || {}).getAttribute ? root.querySelector('.cl-pb__chip.is-on').getAttribute('data-lv') : 'all';
    var stock = stockEl ? stockEl.checked : false, any = false;
    root.querySelectorAll('.cl-pb__shelf').forEach(function(sec){
      var shown = 0;
      sec.querySelectorAll('.cl-pb__card').forEach(function(card){
        var ok = (lv === 'all' || (' ' + card.getAttribute('data-lv') + ' ').indexOf(' ' + lv + ' ') > -1) && (!stock || card.getAttribute('data-a') === 'true');
        card.hidden = !ok; if (ok) shown++;
      });
      sec.hidden = shown === 0; if (shown) any = true;
      var j = root.querySelector('[data-jump="' + sec.getAttribute('data-shelf') + '"]');
      if (j) j.hidden = shown === 0;
    });
    root.querySelector('[data-none]').hidden = any;
  }
  if (root.querySelector('#cl-pb-more')) { var mo = root.querySelector('[data-jump="more"]'); if (mo) mo.hidden = false; }
  filter();

  /* ---- Series list: highlight the shelf being read ---- */
  var jumps = root.querySelectorAll('.cl-pb__jump a[data-jump]');
  function mark(key){ jumps.forEach(function(a){ a.classList.toggle('is-on', a.getAttribute('data-jump') === key); }); }
  if ('IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ seen[e.target.getAttribute('data-shelf')] = e.isIntersecting; });
      var first = null;
      root.querySelectorAll('.cl-pb__shelf').forEach(function(s){ var k = s.getAttribute('data-shelf'); if (!first && !s.hidden && seen[k]) first = k; });
      if (first) mark(first);
    }, { rootMargin: '-130px 0px -55% 0px' });
    root.querySelectorAll('.cl-pb__shelf').forEach(function(s){ io.observe(s); });
  }

  /* ---- Quick look ---- */
  if (!qv) return;
  document.body.appendChild(qv);
  var q = function(s){ return qv.querySelector(s); };
  var track = q('[data-qv-track]'), thumbs = q('[data-qv-thumbs]'), count = q('[data-qv-count]'), info = q('.cl-qv__info');
  var cache = {}, cur = null, pushed = false, lastFocus = null, nImg = 0, atImg = 0, st;

  function getP(h){
    if (!cache[h]) {
      cache[h] = fetch(base + 'products/' + encodeURIComponent(h) + '.js').then(function(r){ if (!r.ok) throw new Error(r.status); return r.json(); });
      cache[h].catch(function(){ delete cache[h]; });
    }
    return cache[h];
  }
  function src(u, w){
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function chip(txt, k){ var s = document.createElement('span'); s.className = 'cl-qv__chip cl-qv__chip--' + k; s.textContent = txt; return s; }
  function visibleCards(){
    return Array.prototype.filter.call(root.querySelectorAll('.cl-pb__card'), function(c){ var sf = c.closest('.cl-pb__shelf'); return !c.hidden && !sf.hidden && !(c.classList.contains('is-extra') && !sf.classList.contains('is-open')); });
  }

  /* Keep the description's words and structure, drop its styles, scripts, images and form bits. */
  var MAP = { p: 'p', div: 'div', blockquote: 'div', section: 'div', ul: 'ul', ol: 'ol', li: 'li', strong: 'strong', b: 'strong', em: 'em', i: 'em', br: 'br', a: 'a', h1: 'h3', h2: 'h3', h3: 'h3', h4: 'h3', h5: 'h3', h6: 'h3', table: 'div', tr: 'div' };
  var DROP = /^(style|script|noscript|img|picture|svg|video|audio|iframe|object|embed|form|input|button|select|textarea|label|link|meta|template)$/;
  /* Before the walk (Clay, 2026-10-18): the level card (data-tjs="level", on most bundles) becomes "Level: N5
     (CEFR A1 · beginner)" plus its tags on one line, without the N5-N1 scale; a group of review cards (a ★★★★★
     row and its quote) keeps its first two; a "#judgeme" link goes to the reviews on the product page. */
  function tidy(box, url){
    var doc = box.ownerDocument, all = Array.prototype.slice;
    all.call(box.querySelectorAll('[data-tjs="level"]')).forEach(function(lv){
      var out = doc.createElement('div'), lab = all.call(lv.querySelectorAll('div')).filter(function(d){ return !d.children.length && /^level$/i.test(d.textContent.trim()); })[0];
      var a = lab && lab.nextElementSibling, b = a && a.nextElementSibling;
      if (a) {
        var p = doc.createElement('p'), s = doc.createElement('strong');
        s.textContent = 'Level: '; p.appendChild(s);
        p.appendChild(doc.createTextNode(a.textContent.trim() + (b ? ' (' + b.textContent.trim() + ')' : '')));
        out.appendChild(p);
      }
      var tags = all.call(lv.querySelectorAll('span')).filter(function(sp){ return /border/.test(sp.getAttribute('style') || ''); });
      if (tags.length) {
        var t = doc.createElement('p');
        tags.forEach(function(sp, i){ if (i) t.appendChild(doc.createTextNode(' · ')); all.call(sp.childNodes).forEach(function(n){ t.appendChild(n.cloneNode(true)); }); });
        out.appendChild(t);
      }
      var hu = lv.querySelector('[data-tjs="human"]');
      if (hu) out.appendChild(hu.cloneNode(true));
      lv.parentNode.replaceChild(out, lv);
    });
    var groups = [];
    all.call(box.querySelectorAll('div,p,span')).forEach(function(e){
      if (e.children.length || !/^[★☆]{4,5}$/.test(e.textContent.trim())) return;
      var card = e.parentElement, g = card && card.parentElement;
      if (!g) return;
      var hit = groups.filter(function(x){ return x.g === g; })[0];
      if (!hit) groups.push(hit = { g: g, cards: [] });
      hit.cards.push(card);
    });
    groups.forEach(function(x){ x.cards.slice(2).forEach(function(c){ c.parentNode.removeChild(c); }); });
    all.call(box.querySelectorAll('a[href^="#judgeme"]')).forEach(function(a){
      if (url) { a.setAttribute('href', url + a.getAttribute('href')); a.textContent = 'Read all the reviews'; }
    });
  }
  function clean(html, url){
    var doc = new DOMParser().parseFromString('<div>' + html + '</div>', 'text/html');
    tidy(doc.body.firstChild, url);
    var out = document.createElement('div');
    (function walk(from, to){
      Array.prototype.forEach.call(from.childNodes, function(nd){
        if (nd.nodeType === 3) { to.appendChild(document.createTextNode(nd.textContent)); return; }
        if (nd.nodeType !== 1) return;
        var tg = nd.tagName.toLowerCase();
        if (DROP.test(tg)) return;
        var nt = MAP[tg];
        if (!nt) {
          walk(nd, to);
          /* side-by-side labels (two spans, two table cells) must not run together */
          if (nd.nextSibling && nd.nextSibling.nodeType === 1) to.appendChild(document.createTextNode(' '));
          return;
        }
        var el = document.createElement(nt);
        if (nt === 'a') {
          var hr = nd.getAttribute('href') || '';
          if (/^(https?:)?\/\//i.test(hr) || hr.charAt(0) === '/') {
            el.href = hr;
            if (el.host && el.host !== location.host) { el.target = '_blank'; el.rel = /amazon\.|amzn\.to/i.test(el.host) ? 'sponsored noopener' : 'noopener'; }
          } else { walk(nd, to); return; }
        }
        walk(nd, el);
        to.appendChild(el);
      });
    })(doc.body.firstChild, out);
    Array.prototype.forEach.call(out.querySelectorAll('p,li,h3,div,strong,em'), function(el){ if (!el.textContent.trim() && !el.querySelector('br,a')) el.remove(); });
    return out;
  }

  function dots(){
    count.textContent = nImg > 1 ? (atImg + 1) + ' / ' + nImg : '';
    count.hidden = nImg < 2;
    q('[data-qv-l]').disabled = atImg <= 0;
    q('[data-qv-r]').disabled = atImg >= nImg - 1;
    Array.prototype.forEach.call(thumbs.children, function(b, i){ b.classList.toggle('is-on', i === atImg); });
  }
  function jump(i){ track.style.scrollBehavior = 'auto'; track.scrollLeft = i * track.clientWidth; track.style.scrollBehavior = ''; }
  function go(i){
    if (i < 0 || i >= nImg) return;
    atImg = i; dots();
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
  }
  track.addEventListener('scroll', function(){
    clearTimeout(st);
    st = setTimeout(function(){ var w = track.clientWidth || 1, i = Math.round(track.scrollLeft / w); if (i !== atImg) { atImg = i; dots(); } }, 60);
  });
  function setImages(list, title, temp){
    track.innerHTML = ''; thumbs.innerHTML = '';
    nImg = list.length; atImg = 0;
    list.forEach(function(u, i){
      var s = document.createElement('div'); s.className = 'cl-qv__slide';
      var im = document.createElement('img');
      im.alt = title + (nImg > 1 ? ', image ' + (i + 1) + ' of ' + nImg : '');
      im.decoding = 'async';
      im.src = temp ? u : src(u, 1000);
      s.appendChild(im); track.appendChild(s);
      if (!temp && nImg > 1) {
        var tb = document.createElement('button');
        tb.type = 'button'; tb.className = 'cl-qv__th'; tb.setAttribute('aria-label', 'Show image ' + (i + 1));
        var ti = document.createElement('img'); ti.alt = ''; ti.loading = 'lazy'; ti.src = src(u, 120);
        tb.appendChild(ti);
        tb.addEventListener('click', function(){ go(i); });
        thumbs.appendChild(tb);
      }
    });
    jump(0); dots();
  }

  function show(card){
    if (!card) return;
    cur = card;
    qv.classList.remove('is-zoom');
    var tl = card.querySelector('.cl-pb__t'), title = tl.textContent.trim();
    q('[data-qv-title]').textContent = title;
    var sh = card.closest('.cl-pb__shelf'), h2 = sh && sh.querySelector('h2');
    q('[data-qv-series]').textContent = h2 ? h2.textContent : '';
    var tags = q('[data-qv-tags]'); tags.innerHTML = '';
    var fl = card.querySelector('.cl-pb__flag'); if (fl) tags.appendChild(chip(fl.textContent, 'f'));
    var ap = card.querySelector('.cl-pb__app'); if (ap) tags.appendChild(chip(ap.textContent, 'a'));
    var buy = q('[data-qv-buy]'); buy.innerHTML = '';
    var bx = card.querySelector('.cl-pb__buy').cloneNode(true);
    var ab = bx.querySelector('.cl-pb__add');
    if (ab) { ab.disabled = false; ab.classList.remove('is-done'); ab.textContent = 'Add to cart'; ab.setAttribute('data-l', 'Add to cart'); }
    buy.appendChild(bx);
    ['.cl-pb__low', '.cl-pb__eb'].forEach(function(s){ var x = card.querySelector(s); if (x) buy.appendChild(x.cloneNode(true)); });
    q('[data-qv-full]').href = tl.href;
    var ci = card.querySelector('.cl-pb__cover img');
    setImages(ci ? [ci.currentSrc || ci.src] : [], title, true);
    var d = q('[data-qv-desc]'); d.innerHTML = '<p class="cl-qv__wait">Loading…</p>';
    getP(card.getAttribute('data-h')).then(function(p){
      if (cur !== card) return;
      if (p.images && p.images.length) setImages(p.images, title, false);
      d.innerHTML = ''; d.appendChild(clean(p.description || '', p.url || ('/products/' + p.handle)));
    }).catch(function(){
      if (cur !== card) return;
      d.innerHTML = '';
      var e = document.createElement('p'); e.textContent = 'The details did not load. ';
      var a = document.createElement('a'); a.href = tl.href; a.textContent = 'Open the book page'; e.appendChild(a); d.appendChild(e);
    });
    var list = visibleCards(), i = list.indexOf(card);
    q('[data-qv-prev]').disabled = i <= 0;
    q('[data-qv-next]').disabled = i < 0 || i >= list.length - 1;
    info.scrollTop = 0; q('.cl-qv__box').scrollTop = 0;
  }
  function open(card){
    if (!card) return;
    if (qv.hidden) lastFocus = document.activeElement;
    qv.hidden = false;
    document.documentElement.classList.add('cl-qv-on');
    show(card);
    if (!pushed) { try { history.pushState({ clqv: 1 }, ''); pushed = true; } catch (e) {} }
    q('.cl-qv__x').focus({ preventScroll: true });
  }
  function close(fromPop){
    if (qv.hidden) return;
    qv.hidden = true; cur = null;
    qv.classList.remove('is-zoom');
    document.documentElement.classList.remove('cl-qv-on');
    if (pushed) { pushed = false; if (!fromPop) history.back(); }
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  function step(dir){ var list = visibleCards(), i = list.indexOf(cur); if (i > -1 && list[i + dir]) show(list[i + dir]); }
  window.addEventListener('popstate', function(){ if (!qv.hidden) { pushed = false; close(true); } });

  qv.addEventListener('click', function(e){
    var tg = e.target;
    if (!tg.closest) return;
    if (tg.closest('[data-qv-close]')) { close(); return; }
    if (tg.closest('[data-qv-prev]')) { step(-1); return; }
    if (tg.closest('[data-qv-next]')) { step(1); return; }
    if (tg.closest('[data-qv-l]')) { go(atImg - 1); return; }
    if (tg.closest('[data-qv-r]')) { go(atImg + 1); return; }
    var b = tg.closest('.cl-pb__add');
    if (b && !b.disabled) { addVariant(b); return; }
    if (tg.closest('.cl-qv__slide img')) {
      qv.classList.toggle('is-zoom');
      var keep = atImg;
      requestAnimationFrame(function(){ jump(keep); });
    }
  });
  document.addEventListener('keydown', function(e){
    if (qv.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); if (qv.classList.contains('is-zoom')) { qv.classList.remove('is-zoom'); var k = atImg; requestAnimationFrame(function(){ jump(k); }); } else close(); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(atImg - 1); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(atImg + 1); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(qv.querySelectorAll('a[href],button:not([disabled])'), function(x){ return x.getClientRects().length > 0; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!qv.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  root.addEventListener('pointerover', function(e){
    if (e.pointerType !== 'mouse' || !e.target.closest) return;
    var cw = e.target.closest('.cl-pb__cw');
    if (cw) getP(cw.closest('.cl-pb__card').getAttribute('data-h')).catch(function(){});
  });
})();
